import { render } from "./HzbaModalItem.vue?vue&type=template&id=289dcf9d"
import script from "./HzbaModalItem.vue?vue&type=script&lang=js"
export * from "./HzbaModalItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__